/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmMatchPreviewTierTraceStepDto
 */
export interface MdmMatchPreviewTierTraceStepDto {
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewTierTraceStepDto
     */
    tierLevel?: number;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewTierTraceStepDto
     */
    tierKey?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewTierTraceStepDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewTierTraceStepDto
     */
    rulesInTier?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewTierTraceStepDto
     */
    matchedRules?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewTierTraceStepDto
     */
    tierScore?: number;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchPreviewTierTraceStepDto
     */
    message?: string;
}

/**
 * Check if a given object implements the MdmMatchPreviewTierTraceStepDto interface.
 */
export function instanceOfMdmMatchPreviewTierTraceStepDto(value: object): value is MdmMatchPreviewTierTraceStepDto {
    return true;
}

export function MdmMatchPreviewTierTraceStepDtoFromJSON(json: any): MdmMatchPreviewTierTraceStepDto {
    return MdmMatchPreviewTierTraceStepDtoFromJSONTyped(json, false);
}

export function MdmMatchPreviewTierTraceStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchPreviewTierTraceStepDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tierLevel': json['tierLevel'] == null ? undefined : json['tierLevel'],
        'tierKey': json['tierKey'] == null ? undefined : json['tierKey'],
        'status': json['status'] == null ? undefined : json['status'],
        'rulesInTier': json['rulesInTier'] == null ? undefined : json['rulesInTier'],
        'matchedRules': json['matchedRules'] == null ? undefined : json['matchedRules'],
        'tierScore': json['tierScore'] == null ? undefined : json['tierScore'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function MdmMatchPreviewTierTraceStepDtoToJSON(json: any): MdmMatchPreviewTierTraceStepDto {
    return MdmMatchPreviewTierTraceStepDtoToJSONTyped(json, false);
}

export function MdmMatchPreviewTierTraceStepDtoToJSONTyped(value?: MdmMatchPreviewTierTraceStepDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tierLevel': value['tierLevel'],
        'tierKey': value['tierKey'],
        'status': value['status'],
        'rulesInTier': value['rulesInTier'],
        'matchedRules': value['matchedRules'],
        'tierScore': value['tierScore'],
        'message': value['message'],
    };
}

